//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    content: {
      type: String,
      default:
        "Faites forte impression avec une communication visuelle puissante et reconnaissable entre mille.",
    },

    image: {
      type: String,
      default: "fou-terroir-packaging.jpg",
    },

    tags: {
      type: Object,
      default: () => ({
        customer: "Les Fous de Terroirs",
        services: ["Identité"],
      }),
    },
    objectPosition: {
      type: String,
      default: "object-center",
    },
    hideTags: {
      type: Boolean,
      default: false,
    },
  },
};
